import React from "react";

import TeamCard from "../../../components/cards/teamCard";

const Placements = ({
  partners,
  placementsIntroText,
  placementsSubText,
  placementsHeading = "Placements",
  placementsSubHeading = "Partners"
}) => {
  return (
    <>
      <h2
        className="heading text-left py-5"
        dangerouslySetInnerHTML={{ __html: placementsHeading }}
      />
      <div className="divide-y width-divider" />

      {placementsIntroText && (
        <div
          className="planet:gvi-light-gray-text  text-black-lighter text-sm pt-5 tab-content_html whitespace-pre-wrap"
          dangerouslySetInnerHTML={{ __html: placementsIntroText }}
        />
      )}

      {partners && partners?.length > 0 && (
        <>
          <h2
            className="heading text-left py-10"
            dangerouslySetInnerHTML={{ __html: placementsSubHeading }}
          />

          {placementsSubText && (
            <div
              className="planet:gvi-light-gray-text  text-black-lighter text-sm tab-content_html"
              dangerouslySetInnerHTML={{ __html: placementsSubText }}
            />
          )}

          <div className="grid gap-2 grid-cols-1 md:grid-cols-2 py-2 text-sm  pt-5">
            {partners?.map((partner, idx) => (
              <div
                key={idx}
                className="flex items-top justify-center p-2 col-span-1 md:col-span-2 lg:col-span-1"
              >
                <TeamCard
                  sourceUrl={partner?.image?.sourceUrl}
                  title={partner?.name}
                  bgImage={partner?.image}
                  memberTitle={""}
                  content={partner?.description}
                  uri={""}
                  memberVideo={""}
                  contectClass="lato-400-latin text-sm font-normal not-italic text-generic-text planet:text-gray-generic tab-content_html"
                  size="sm"
                />
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default Placements;
